import { useState } from 'react';
import { Card, Tabs } from 'antd';
import HeadingTypography from 'src/app/components/shared/Typography/Heading';
import { useLeadContext } from '@contexts';
import { LeadsTable } from 'src/app/components/shared/LeadsTable/LeadsTable';

const LeadCredit = () => {
    const [activeTab, setActiveTab] = useState('1');
    const { creditFiltars, setCreditFiltars, repeatedCreditFilters, setRepeatedCreditFilters, rejectedLeadFilters, setRejectedLeadFilters, approvedLeadFilters, setApprovedLeadFilters } =
        useLeadContext();

    return (
        <div className="pt-4 bg-gray-100 rounded-lg">
            <Card>
                <div className="border-2 border-black rounded-lg overflow-visible">
                    <Tabs
                        defaultActiveKey="1"
                        onChange={key => setActiveTab(key)}
                        tabBarStyle={{ borderBottom: '1px solid #d9d9d9', display: 'flex', alignItems: 'center', overflow: 'visible' }}
                        className="text-lg font-semibold tabs-custom-style"
                    >
                        <Tabs.TabPane
                            key="1"
                            tab={
                                <>
                                    <HeadingTypography
                                        fontSize={16}
                                        classNames={`flex items-center h-[40px] px-[20px] ${activeTab === '1' ? 'font-medium' : '!font-light text-gray-400 text-[#DBD7D7]'}`}
                                    >
                                        Pending
                                    </HeadingTypography>
                                    {activeTab === '1' && <div className="absolute bottom-[0px] z-10 left-0 w-full h-[2px] bg-[#FCD4D6]" />}
                                </>
                            }
                        >
                            <LeadsTable
                                tabKey={'1'}
                                activeTab={activeTab}
                                savedFilters={creditFiltars}
                                setSavedFilters={setCreditFiltars}
                                actions={true}
                                tableType="pendingCreditLeads"
                                isAddButton={false}
                                optionalColumns={['id', 'agent', 'first_name', 'last_name', 'email', 'phone', 'cnic', 'created_at', 'comment']}
                                optionalActions={['view', 'approved', 'rejected', 'hold']}
                            />
                        </Tabs.TabPane>

                        <Tabs.TabPane
                            key="2"
                            tab={
                                <>
                                    <HeadingTypography
                                        fontSize={16}
                                        classNames={`flex items-center h-[40px] px-[20px] ${activeTab === '2' ? 'font-medium' : '!font-light text-gray-400 text-[#DBD7D7]'}`}
                                    >
                                        Repeated
                                    </HeadingTypography>
                                    {activeTab === '2' && <div className="absolute bottom-[0px] z-10 left-0 w-full h-[2px] bg-[#FCD4D6]" />}
                                </>
                            }
                        >
                            <LeadsTable
                                tabKey={'2'}
                                activeTab={activeTab}
                                savedFilters={repeatedCreditFilters}
                                setSavedFilters={setRepeatedCreditFilters}
                                actions={true}
                                tableType="repeatedCreditLeads"
                                isAddButton={false}
                                optionalColumns={['id', 'agent', 'first_name', 'last_name', 'email', 'phone', 'cnic', 'created_at', 'comment']}
                                optionalActions={['view', 'approved', 'rejected', 'hold']}
                            />
                        </Tabs.TabPane>

                        <Tabs.TabPane
                            key="3"
                            tab={
                                <>
                                    <HeadingTypography
                                        fontSize={16}
                                        classNames={`flex items-center h-[40px] px-[20px] ${activeTab === '3' ? 'font-medium' : '!font-light text-gray-400 text-[#DBD7D7]'}`}
                                    >
                                        Approved
                                    </HeadingTypography>
                                    {activeTab === '3' && <div className="absolute bottom-[0px] z-10 left-0 w-full h-[2px] bg-[#FCD4D6]" />}
                                </>
                            }
                        >
                            <LeadsTable
                                tabKey={'3'}
                                activeTab={activeTab}
                                savedFilters={approvedLeadFilters}
                                setSavedFilters={setApprovedLeadFilters}
                                actions={false}
                                tableType="approvedCreditLeads"
                                isAddButton={false}
                                optionalColumns={['id', 'agent', 'first_name', 'last_name', 'email', 'phone', 'cnic', 'created_at', 'comment']}
                            />
                        </Tabs.TabPane>

                        <Tabs.TabPane
                            key="4"
                            tab={
                                <>
                                    <HeadingTypography
                                        fontSize={16}
                                        classNames={`flex items-center h-[40px] px-[20px] ${activeTab === '4' ? 'font-medium' : '!font-light text-gray-400 text-[#DBD7D7]'}`}
                                    >
                                        Rejected
                                    </HeadingTypography>
                                    {activeTab === '4' && <div className="absolute bottom-[0px] z-10 left-0 w-full h-[2px] bg-[#FCD4D6]" />}
                                </>
                            }
                        >
                            <LeadsTable
                                tabKey={'4'}
                                activeTab={activeTab}
                                savedFilters={rejectedLeadFilters}
                                setSavedFilters={setRejectedLeadFilters}
                                actions={false}
                                tableType="rejectedCreditLeads"
                                isAddButton={false}
                                optionalColumns={['id', 'agent', 'first_name', 'last_name', 'email', 'phone', 'cnic', 'created_at', 'comment']}
                            />
                        </Tabs.TabPane>
                    </Tabs>
                </div>
            </Card>
        </div>
    );
};

export default LeadCredit;
